var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dynamicComponent)?_c(_vm.dynamicComponent,{tag:"component",staticClass:"svg-component",class:{ 'no-dark-style': _vm.isPeugeot }}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }